import { z } from "zod";

/// URL search params for the full leave history page.
///
/// `period` is a `LeavePeriod` id and behaves exactly as it does on `/leave`:
/// the page falls back rather than errors when it names one the reader cannot
/// see (`selectPeriod`). It is what the "View all" link carries across, so the
/// two pages open on the same leave year, and what makes a link to a
/// particular year shareable.
export const leaveHistoryRouteSearchSchema = z
  .object({
    period: z.string().optional(),
  })
  .strict();

export type LeaveHistoryRouteSearch = z.infer<typeof leaveHistoryRouteSearchSchema>;
